import { readCheckedValues } from '../../field-viewer/prehydration-readers';
import { removeInvalidOptions } from '../../field-viewer/shared-normalizers';
export const dextTagsViewer = {
    normalizeLoadedValue: removeInvalidOptions,
    readPrehydrationValue: readCheckedValues
};

//# sourceMappingURL=definition-viewer.js.map